import { createContext, use } from 'react';
import type { Table } from '@tanstack/react-table';

interface TableContextValue<TData> {
  table: Table<TData>;
}

const TableContext = createContext<TableContextValue<unknown> | null>(null);

export const TableProvider = TableContext;

export const useTableContext = <TData,>() => {
  const context = use(TableContext);

  if (!context) {
    throw new Error('Table components must be used within TableRoot.');
  }

  return context as TableContextValue<TData>;
};
